import {
    faArrowLeft,
    faCircleExclamation,
    faPersonToDoor,
    type IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export const regularIcons: IconDefinition[] = [
    faArrowLeft,
    faPersonToDoor,
    faCircleExclamation,
];
